import "./Verification.scss";
import { useState } from "react";
import Button from "components/Button/Button";
import FormCheckbox from "components/FormCheckbox/FormCheckbox";
import { useAppSelector } from "store";
import { useTranslation, Trans } from "react-i18next";

interface VerificationProps {
  isIndividualClient: boolean;
  isSOFVerification: boolean;
}
const Verification = ({
  isIndividualClient,
  isSOFVerification,
}: VerificationProps) => {
  const { KYCUrl, KYBUrl, proofOfFundsUrl } = useAppSelector(
    (state) => state.exchange
  );
  const { t } = useTranslation();
  const openVerificationWindow = () => {
    if (isSOFVerification) {
      window.location.href = proofOfFundsUrl?.formUrl ?? "";
    } else
      window.location.href = isIndividualClient
        ? (KYCUrl?.formUrl ?? "")
        : (KYBUrl?.formUrl ?? "");
  };
  const popupHeader = isSOFVerification
    ? t("popups.verificationPopup.title2")
    : t("popups.verificationPopup.title");
  const popupSubTitle1 = isSOFVerification
    ? t("popups.verificationPopup.description3")
    : t("popups.verificationPopup.description1");

  return (
    <div className="verification-area">
      <div className="main-title">{popupHeader}</div>
      <div className="sub-title">{popupSubTitle1}</div>
      <div className="verification-text">
        {t("popups.verificationPopup.description2")}
      </div>
      <Button
        btnName={t("buttons.continue")}
        className="blue-btn"
        onClick={() => openVerificationWindow()}
      />
    </div>
  );
};

export default Verification;
